<template>
  <div>
    <section class="scrollable bg-dark">
      <nav class="navbar navbar-expand-lg navbar-light bg-dark px-5 mb-5">
        <a class="navbar-brand" href="/">
          <img alt="Indiefy Network" class="mr-2" src="/static/img/logo-contorno-white.png" width="25" height="25"> <span class="text-white font-thin">Indiefy Network</span>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
          </ul>
          <div class="my-2 my-lg-0">
          </div>
          <ul class="navbar-nav align-items-center">
            <li>
              <a href="https://indiefy.net/services" class="btn btn-lg text-white fw-light">{{ $t('more_services') }}</a>
            </li>
            <li>
              <a href="https://indiefy.net" class="btn btn-lg text-white fw-light">{{ $t('music_distribution') }}</a>
            </li>
            <li>
              <router-link :to="loginUrl" class="btn btn-lg strong text-white">
                <span v-if="loggedIn">{{ $t('dashboard') }}</span>
                <span v-else>{{ $t('get_access') }}</span>
              </router-link>
            </li>
            <li class="nav-item dropdown hidden-caret submenu">
              <a class="nav-link dropdown-toggle btn-lg" href="#" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-language"></i>
              </a>
              <ul class="dropdown-menu animated fadeIn" aria-labelledby="messageDropdown">
                <li>
                  <a :href="`/?lang=en`" class="dropdown-item">
                    English
                  </a>
                </li>
                <li>
                  <a :href="`/?lang=es`" class="dropdown-item">
                    Español
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <div class="d-none d-md-block pt-5"></div>
      <section class="bg-dark scrollable">
        <div class="row">
          <div class="col-md-7 px-5">
            <div class="mb-2">
              <h1 class="text-white landing-main-title" v-html="$t('landing_main_title')"></h1>
              <p class="h4 text-white landing-sub-title" v-html="$t('landing_sub_title')">
              </p>
            </div>
            <div class="row mt-5 mb-5">
              <div class="col-md-6">
                <router-link :to="loginUrl" class="btn btn-primary btn-lg strong w-100">
                  <span v-if="loggedIn">{{ $t('dashboard') }}</span>
                  <span v-else>{{ $t('get_access') }}</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <img src="/static/img/landing-people.png" alt="" width="100%" class="mt-2 mb-2">
          </div>
        </div>
      </section>
    </section>
    <Footer></Footer>
  </div>
</template>
<script>

import Footer from '../components/Footer'

export default {
  name: 'Landing',
  data: function () {
    return {
      loggedIn: false,
      loginUrl: 'login'
    }
  },
  mounted: function () {},
  created () {
    this.loginUrl = this.getLoginUrl()
  },
  methods: {
    getLoginUrl: function () {
      if (this.$user && this.$user._id) {
        this.loggedIn = true
        return '/campaigns'
      } else {
        this.loggedIn = false
        return '/login'
      }
    }
  },
  components: {
    Footer
  }
}
</script>
<style scoped>
 .landing-main-title {
    font-size: 80px;
 }

 .landing-sub-title {
    font-size: 25px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue